import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import Img from 'gatsby-image'

const Influencer = styled.li`
  background: ${props => props.theme.colors.white};
  position: relative;
  width: 98%;
  transition: background 0.2s;

  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    flex: ${props => (props.featured ? '0 0 100%' : '0 0 49%')};
    margin: 0 0 2vw 0;
  }
  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    flex: ${props => (props.featured ? '0 0 100%' : '0 0 32%')};
  }

  &:hover {
    background: ${props => props.theme.colors.white};
  }
  a {
    display: flex;
    flex-flow: column;
    height: 100%;
    width: 100%;
    color: ${props => props.theme.colors.base};
    text-decoration: none;
    .gatsby-image-wrapper {
      height: 0;
      padding-bottom: 60%;
      @media screen and (min-width: ${props => props.theme.responsive.small}) {
        padding-bottom: ${props => (props.featured ? '40%' : '60%')};
      }
    }
  }

  .showme {
    display: none;
  }
  @media only screen and (max-width: ${props => props.theme.responsive.large}) {
    .showme {
      display: block;
    }
  }

  @media screen and (min-width: ${props => props.theme.responsive.large}) {
    .showhim:hover .showme {
      display: block;
    }
    .showhim:hover .ok {
      display: none;
    }
  }
`

const Name = styled.h2`
  margin: auto;
  width: auto;
  margin-top: 1em;
  font-family: Prompt;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.4px;
  text-align: center;
  color: ${props => props.theme.colors.secondary};
  font-weight: 500;
`

const BgImg = styled(Img)`
  min-height: 315px;
  margin-top: 0.5em;
`

const HoverContent = styled.div`
  height: 323px; 

  padding: 1em;
  font-family: Cormorant;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.1px;
  text-align: center;
  color: ${props => props.theme.colors.secondary};
`
const HoverContentTitle = styled.div`
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.1px;
`




const HoverContentDivider = styled.div`
  margin: 0 auto;
  margin-top: 2em;
  width: 110px;
  height: 2px;
  border: solid 1.5px #090c30;
`

const Headline = styled.h3`
  font-family: Cormorant;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.4px;
  text-align: center;
  color: ${props => props.theme.colors.secondary};
`

const Card = ({
  slug,
  name,
  heroImage,
  title,
  description,
  descriptionTitle,
  ...props
}) => {
  let imagePhoto = ''
  if (heroImage != null) {
    imagePhoto = <BgImg className="ok" fluid={heroImage.fluid} />
  }
  //to={`/${slug}/`}
  //
  return (
    <Influencer featured={props.featured}>
      <div className="showhim">
        {imagePhoto}
        <Name>{name}</Name>
        <Headline>{title}</Headline>
        <HoverContent className="showme">
          <HoverContentTitle>{descriptionTitle}</HoverContentTitle>
          <div
          dangerouslySetInnerHTML={{ __html: description.childMarkdownRemark.html }}
          ></div>
          
          
          <HoverContentDivider />
        </HoverContent>
      </div>
    </Influencer>
  )
}

export default Card
